<template>
  <div class="PaymentMethod_wrapper">
    <slot name="payment-tips"></slot>

    <div class="PaymentMethod_card">
      <div class="PaymentMethod_card-notCredit" v-if="paymentMethodsNotCreditCard.length > 0">
        <!-- <h3 class="title-sub">{{ $t('checkout.payment.subTitle.selectMethod', 'Select a payment method') }}</h3> -->
        <div class="PaymentMethod_itemWrapper">
          <div class="PaymentMethod_item" v-for="item in paymentMethodsNotCreditCard" :key="item.name">
            <app-radio
              :value="item.code"
              :id="item.name"
              v-model="paymentMethodCode"
              :data-name="`paymentMethod-${item.name}`"
              :disabled="paymentMethodSubmitActive || ( item.name === 'Paypal' && sbeCompliance === 'False')"
              :class="(item.name === 'Paypal' && sbeCompliance === 'False') ? 'opacity' : ''"
              
            >
              <span class="icon_box">
                <img :src="item.logoUrl">
              </span>
            </app-radio>
            <span class="paypalmsg" v-show="item.name === 'Paypal' && sbeCompliance === 'False'"> {{$t('paymentMethod.verification.sbe','Paypal is disabled')}} </span>
          </div>
        </div>
      </div>

      <div class="PaymentMethod_card-credit" v-if="paymentMethodsCreditCardtempUK.length > 0 && currentCountryCode === 'GB' && sbeCompliance === 'False' ">
        <!-- <h3 class="title-sub">{{ $t('checkout.payment.subTitle.creditCards', 'Credit cards') }}</h3> -->
        <div class="PaymentMethod_itemWrapper">
          <div class="PaymentMethod_item" v-for="item in paymentMethodsCreditCardtempUK" :key="item.name">
            <app-radio
              :value="item.code"
              :id="item.name"
              v-model="paymentMethodCode"
              :data-name="`paymentMethod-${item.name}`"
              :disabled="paymentMethodSubmitActive"
            >
              <span class="icon_box">
                <img :src="item.logoUrl">
              </span>
            </app-radio>
          </div>
        </div>
      </div>

      <div class="PaymentMethod_card-credit" v-if="paymentMethodsCreditCardtemp.length > 0 && currentCountryCode === 'GB' && sbeCompliance === 'True'">
        <!-- <h3 class="title-sub">{{ $t('checkout.payment.subTitle.creditCards', 'Credit cards') }}</h3> -->
        <div class="PaymentMethod_itemWrapper">
          <div class="PaymentMethod_item" v-for="item in paymentMethodsCreditCardtemp" :key="item.name">
            <app-radio
              :value="item.code"
              :id="item.name"
              v-model="paymentMethodCode"
              :data-name="`paymentMethod-${item.name}`"
              :disabled="paymentMethodSubmitActive"
            >
              <span class="icon_box">
                <img :src="item.logoUrl">
              </span>
            </app-radio>
          </div>
        </div>
      </div>

      <div class="PaymentMethod_card-credit" v-if="paymentMethodsCreditCard.length > 0 && currentCountryCode != 'GB'">
        <!-- <h3 class="title-sub">{{ $t('checkout.payment.subTitle.creditCards', 'Credit cards') }}</h3> -->
        <div class="PaymentMethod_itemWrapper">
          <div class="PaymentMethod_item" v-for="item in paymentMethodsCreditCard" :key="item.name">
            <app-radio
              :value="item.code"
              :id="item.name"
              v-model="paymentMethodCode"
              :data-name="`paymentMethod-${item.name}`"
              :disabled="paymentMethodSubmitActive"
            >
              <span class="icon_box">
                <img :src="item.logoUrl">
              </span>
            </app-radio>
          </div>
        </div>
      </div>
    </div>
    <div class="PaymentMethod_footer">
      <slot name="payment-footer"></slot>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { find } from 'lodash'
  import { detectedCulture } from '@/utilities/common/culture'
  import paymentDetails from 'views/my-account/PaymentDetails'

  export default {
    name: 'payment-methods',

    data () {
      return {
        paymentMethodCode: null,
        currentCountryCode: detectedCulture.countryCode,
        paymentDetails
      }
    },

    props: {
      paymentMethodSubmitActive: {
        type: Boolean,
        default: false
      },
      sbeflag: {
        type: Boolean,
        default: false
      }  
    },

    computed: {
      ...mapState('account', {
       
        sbeCompliance: state => state.profile.personalDetail.sbeCompliance
      }),

      ...mapState('culture', ['paymentMethods']),

      ...mapGetters('culture', ['paymentMethodsCreditCard', 'paymentMethodsCreditCardtemp', 'paymentMethodsCreditCardtempUK', 'paymentMethodsNotCreditCard']),

      paymentMethodName () {
        return this.paymentMethodCode && find(this.paymentMethods, { 'code': this.paymentMethodCode }).name
      }
    },

    watch: {
      paymentMethodCode (newVal) {
        if (newVal) {
          this.trackConversion({ name: 'interaction', description: 'button:payment_method' })
          this.$emit('payment-method-selected', { code: this.paymentMethodCode, name: this.paymentMethodName })
        }
      }
    }
  }
</script>

<style lang="scss">
  .PaymentMethod {
    &_wrapper {
      background: $block-bg;
      margin-bottom: .22rem;
      padding: .24rem .1rem;
      border-radius: .02rem;

      @include media(tablet) {
        padding: .36rem .24rem;
      }
    }

    &_card {
      @include media(tablet) {
        display: flex;
      }

      .title-sub {
        line-height: 1;
      }

      &-notCredit {
        margin-bottom: .28rem;

        @include media(tablet) {
          flex: 1;
          margin: 0;

          + .PaymentMethod_card-credit {
            flex: 2;
            margin-left: .5rem;
          }
        }
      }
    }

    &_itemWrapper {
      display: flex;
      flex-wrap: wrap;
    }

    &_item {
      cursor: pointer;
      margin-top: .1rem;
      margin-right: .12rem;

      input[type="radio"]:checked {
        + label {
          .icon_box {
            border-width: .02rem;
            border-color: $pink;
          }
        }
      }

      .paypalmsg {
        font-size: 0.1rem;
        background: #0066a1;
        color: #fff;
        padding: 2px;
      }
    }
  }
</style>
